import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-semantic-toasts";



const errorHandler = (response, t) => {
    //const { t } = useTranslation();
    // console.log(response);
    switch(response.data){
        case "schedule-ok":
          toast({
            type: 'success',
            title: t('schedule-ok'),
            time: 3500,
            size: "small",
            });
          break
        case "schedule-min-time-required":
          toast({
            type: 'error',
            description: t('schedule-min-time-required-content'),
            title: t('schedule-min-time-required'),
            time: 3500,
            size: "small",
            });
          break
        case "schedule-already-reserved":
          toast({
            type: 'error',
            description: t('schedule-already-reserved-content'),
            title: t('schedule-already-reserved'),
            time: 3500,
            size: "small",
          });
          break
        case "schedule-time-passed":
            toast({
                type: 'error',
                description: t('schedule-time-passed-content'),
                title: t('schedule-time-passed'),
                time: 3500,
                size: "small",
            });
            break
        case "schedule-invalid-time":
            toast({
                type: 'error',
                title: t('schedule-invalid-time'),
                time: 3500,
                size: "small",
            });
            break
        case "schedule-not-reserved":
            toast({
                type: 'error',
                description: t('schedule-not-reserved-content'),
                title: t('schedule-not-reserved'),
                time: 3500,
                size: "small",
            });
            break
        case "cancel-deny":
            toast({
                type: 'error',
                description: t('cancel-deny-content'),
                title: t('cancel-deny'),
                time: 3500,
                size: "small",
            });
            break
        case "invalid-data":
            toast({
                type: 'error',
                description: t('invalid-data-content'),
                title: t('invalid-data'),
                time: 3500,
                size: "small",
            });
            break
        case "invalid-name":
          toast({
            type: 'error',
            description: t('invalid-name-content'),
            title: t('invalid-name'),
            time: 3500,
            size: "small",
          });
          break
        case "invalid-course":
          toast({
            type: 'error',
            description: t('invalid-course-content'),
            title: t('invalid-course'),
            time: 3500,
            size: "small",
          });
          break
        default:
        break;
      }
};

export default errorHandler;